module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts-block"
  }, [_c('div', {
    staticClass: "echarts-contant",
    attrs: {
      "id": _vm.chart_id
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37b65d53"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Echarts.vue
// module id = 786
// module chunks = 1